import {computed} from 'vue'
import { useGlobalStore } from '@/stores/index'

export const useAbstractPartsStore = () =>
{

    const globals = useGlobalStore()

    const apiUrlGetParts = computed(() =>
    {
        return 'api/parts'
    })

    const apiUrlGetCableConfigurations = computed(() =>
    {
        return 'api/cable_configurations'
    })

    const imagePath = computed(() =>
    {
        return globals.apiBase + '/upload/images'
    })

    const apiUrlGetAssemblyInstructionPath = computed(() =>
    {
        return globals.apiBase + '/upload/assembly-instructions'
    })

    const apiUrlGetStpFilesPath = computed(() =>
    {
        return globals.apiBase + '/upload/stp-files'
    })

    const mouserApiKey = 'fedb9f84-8aa6-42d1-a22e-f3211d650e0b'
    const digiKeyClientId = 'NK1uGM0DbE4DP85IjIcGBUEGBXUuPfeC'

    return {
        apiUrlGetParts,
        imagePath,
        apiUrlGetAssemblyInstructionPath,
        apiUrlGetStpFilesPath,
        apiUrlGetCableConfigurations,
        mouserApiKey,
        digiKeyClientId
    }
}
